var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.numDates > 0
    ? _c("section", { staticClass: "mb-4" }, [
        _c("span", [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$t("message.booking.new_booking.number_of_booking", {
                  count: _vm.numDates
                })
              ) +
              "\n  "
          )
        ]),
        _vm._v(" "),
        _vm.discount > 0
          ? _c("span", { staticClass: "mt-2 ml-2" }, [
              _c("i", { staticClass: "fas fa-check-circle -status-accepted" }),
              _vm._v(
                "\n    " +
                  _vm._s(
                    _vm.$t("message.booking.new_booking.package_discount", {
                      discount: _vm.discount
                    })
                  ) +
                  "\n  "
              )
            ])
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-136ca0c0", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-136ca0c0","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/newSteps/components/PackageDiscount.vue
// module id = 1261
// module chunks = 0